import { Button, Space } from "antd";
import { setIcons } from "@/utils/common";
import { channelLevelAreaTree } from "@/api/setting";
import { useCallback, useState } from "react";



const ChannelLevelEnum: Record<number, string> = {
  1: "channelProvinceId",
  2: "channelCityId",
  3: "channelDistrictId",
};

const channelLevelData = [
  {
    label: "省级",
    value: 1,
  },
  {
    label: "市级",
    value: 2,
  },
  {
    label: "区级",
    value: 3,
  },
];

export const columns = ({
  setModalFormData,
  setOpen,
  deleteOutletsData,
  fetchAreaData,
  setAddProxyOpen,
  loadByIds
}: {
  setModalFormData: any;
  setOpen: any;
  deleteOutletsData: any;
  fetchAreaData: any;
  setAddProxyOpen: any;
  loadByIds: any;
}) => [
  {
    title: "渠道等级",
    dataIndex: "channelLevel",
    key: "channelLevel",
    render: (val: number) => {
      const level = channelLevelData.find((item) => item.value === val);
      return level ? level.label : "";
    },
  },
  // {
  //   title: "渠道名称",
  //   dataIndex: "channelName",
  //   key: "channelName",
  // },
  {
    title: "区域范围",
    dataIndex: "channelName",
    key: "channelName",
    render: (val: string, rows: any) => {
      return (
        `${rows.channelProvinceName || ""} ${rows.channelCityName ? ` - ${rows.channelCityName}` : ""}${rows.channelDistrictName ? ` - ${rows.channelDistrictName}` : ""}`
      );
    },
  },
  {
    title: "设备目标量",
    dataIndex: "channelApplyDeviceCount",
    key: "channelApplyDeviceCount",
  },
  {
    title: "代理人账号",
    dataIndex: "channelAgentMobile",
    key: "channelAgentMobile",
  },
  {
    title: "代理人昵称",
    dataIndex: "channelAgentNickName",
    key: "channelAgentNickName",
  },
  {
    title: "渠道代理推荐人",
    dataIndex: "channelAgentRecommendNickName",
    key: "channelAgentRecommendNickName",
  },  
  {
    title: "渠道代理推荐人账号",
    dataIndex: "channelAgentRecommendMobile",
    key: "channelAgentRecommendMobile",
  },
  {
    title: "渠道代理推荐人ID",
    dataIndex: "channelAgentRecommendBusinessId",
    key: "channelAgentRecommendBusinessId",
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "创建时间",
    dataIndex: "updateTime",
    key: "updateTime",
  },
  {
    title: "操作",
    dataIndex: "id",
    key: "id",
    fixed: "right",
    width: "120px",
    render: (val: string, rows: any) => (
      <Space>
        <Button
          size="small"
          icon={setIcons("EditOutlined")}
          type="text"
          onClick={(e) => {
            const channelName = [rows.channelProvinceId || "", rows.channelCityId || "", rows.channelDistrictId || ""]?.filter(i=>i)
            setModalFormData({
              ...rows,
              channelName
            });
            setOpen(true);
            loadByIds(channelName);
          }}
        >
          修改
        </Button>
        {
          !rows.channelAgentUserId && (
            <Button
            size="small"
            icon={setIcons("ClusterOutlined")}
            type="text"
            onClick={(e) => {
              setAddProxyOpen(true);
              setModalFormData({
                ...rows
              });
              // setOpen(true);
            }}
          >
            添加代理人
          </Button>
          )
        }
    
        <Button
          size="small"
          icon={setIcons("DeleteOutlined")}
          type="text"
          onClick={(e) => {
            deleteOutletsData(val);
          }}
        >
          删除
        </Button>
      </Space>
    ),
  },
];

